export const EMAIL_PATTERN = /^[^\s@$|]+@[^\s@$|]+\.[^\s@$|]+$/;
